/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown>, count: NonNullable<unknown> }} Meeting_Journey_LabelInputs */



/**
* | output |
* | --- |
* | "{name} · step {position} of {count}" |
*
* @param {Meeting_Journey_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_journey_label = /** @type {((inputs: Meeting_Journey_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Journey_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} · stap ${i?.position} van ${i?.count}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} · étape ${i?.position} sur ${i?.count}`)
	return /** @type {LocalizedString} */ (`${i?.name} · step ${i?.position} of ${i?.count}`)
});